import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { ArPageHero, ArBlock, ArGrid, ArContactCTA } from "@/pages/ar/_ArShared";
import { MeyarLogo } from "@/components/MeyarLogo";

export default function MeyarOverviewAr() {
  return (
    <div data-testid="meyar-overview-ar">
      <Seo title="Meyar — المعيار الذي تُقاس به مؤسستكم" description="منصة الحوكمة والمخاطر والامتثال — سجل مخاطر ومسار أدلة وضوابط مربوطة بالأطر، بالعربية والإنجليزية." />
      <section className="bg-wafa-cream/40">
        <div className="mx-auto max-w-7xl px-4 py-16 lg:px-6 lg:py-24">
          <nav className="mb-6 text-xs text-wafa-ink/60">
            <Link to="/ar" className="hover:text-wafa-deep">الرئيسية</Link>
            <span className="mx-1">/</span>
            <span>Meyar</span>
          </nav>
          <div className="mb-6"><MeyarLogo className="h-10" /></div>
          <h1 className="font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
            Meyar — المعيار الذي تُقاس به مؤسستكم
          </h1>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
            معظم المؤسسات هنا تدير الحوكمة عبر جداول بيانات. سجل المخاطر في ملف، السياسات في مجلد مشترك، الأدلة في بريد أحدهم الإلكتروني. يصمد هذا النظام إلى أن يصل المدقق.
          </p>
          <p className="mt-4 max-w-3xl text-base leading-relaxed text-wafa-ink/85 lg:text-lg">
            تجمع Meyar كل ذلك في مكان واحد — مترابط، موثّق بالإصدارات، وجاهز للعرض.
          </p>
          <div className="mt-8">
            <Link to="/ar/company/contact" className="inline-flex items-center gap-1.5 rounded-md bg-wafa-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-wafa-deep">
              احجزوا عرضًا تجريبيًا لمدة 20 دقيقة
            </Link>
          </div>
        </div>
      </section>

      <ArBlock tint="white" heading="جدول البيانات ينهار دائمًا في الأماكن نفسها الخمسة">
        <ArGrid columns={3} items={[
          { title: "لا أحد يعرف أي نسخة هي الصحيحة", desc: "تتناقض النسخ المشتركة، وتفقد سجل ما تغيّر ومتى." },
          { title: "الضوابط موجودة على الورق فقط", desc: "توثيق دون تنفيذ، لا رابط بين السياسة والدليل." },
          { title: "تُجمع الأدلة في الأسبوع الأخير قبل التدقيق", desc: "سباق مع الوقت لتجميع ما كان ينبغي تسجيله باستمرار." },
          { title: "يرى مجلس الإدارة تقريرًا كل ربع سنة فقط", desc: "لا رؤية حية للمخاطر أو الامتثال بين الاجتماعات." },
          { title: "يسأل المنظم سؤالًا وتحتاجون ثلاثة أيام للرد", desc: "لأن الجواب موزّع بين أربعة أشخاص وثلاثة مجلدات." },
        ]} />
      </ArBlock>

      <ArBlock tint="cream" heading="اختاروا المسار المناسب">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <div className="rounded-lg bg-white p-6">
            <div className="font-heading text-xl font-semibold text-wafa-deep">Meyar Enterprise GRC</div>
            <p className="mt-3 text-sm leading-relaxed text-wafa-ink/80">لفرق المخاطر والامتثال والتدقيق الداخلي ومجلس الإدارة.</p>
            <Link to="/ar/meyar/enterprise-grc" className="mt-4 inline-flex text-sm font-semibold text-wafa-primary hover:text-wafa-deep">
              اعرف المزيد ←
            </Link>
          </div>
          <div className="rounded-lg bg-white p-6">
            <div className="font-heading text-xl font-semibold text-wafa-deep">Meyar Cyber Security GRC</div>
            <p className="mt-3 text-sm leading-relaxed text-wafa-ink/80">لمسؤول أمن المعلومات وفرق حوكمة تقنية المعلومات.</p>
            <Link to="/ar/meyar/cyber-security-grc" className="mt-4 inline-flex text-sm font-semibold text-wafa-primary hover:text-wafa-deep">
              اعرف المزيد ←
            </Link>
          </div>
        </div>
        <p className="mt-6 text-sm italic text-wafa-ink/70">
          ابدأوا بواحدة، وأضيفوا الأخرى عند الجاهزية. كلاهما يعمل على المنصة ذاتها، فلا شيء يُعاد بناؤه أو إدخاله مجددًا.
        </p>
      </ArBlock>

      <ArBlock tint="white" heading="ما تشتركان فيه">
        <ArGrid columns={3} items={[
          { title: "الذكاء الاصطناعي على كل بند مخاطرة", desc: "يقترح المساعد الضابط، يصيغ خطة المعالجة، ويقترح صياغة يقبلها المدقق." },
          { title: "سجل مخاطر يتصرف كسجل فعلي", desc: "تقييم أصلي وتقييم متبقٍّ، مع سجل تغييرات كامل." },
          { title: "ضوابط تُبنى مرة وتُستخدم دائمًا", desc: "ربط بين الأطر المختلفة، فلا يُعاد إدخال الضابط لكل تدقيق." },
          { title: "إدارة سياسات بإقرارات موثقة", desc: "من قرأ، ومتى، وعلى أي نسخة." },
          { title: "أدلة تُجمع باستمرار", desc: "من الأنظمة الحية، لا في الأسبوع قبل التدقيق." },
          { title: "لوحات معلومات وتقارير مجلس إدارة بضغطة واحدة", desc: "عربي وإنجليزي، كلاهما أصيل." },
        ]} />
      </ArBlock>

      <ArContactCTA heading="جاهزون لإخراج الحوكمة من الجداول؟" />
    </div>
  );
}
